<template>
  <div>
    <!-- Usuarios -->
    <div>
      <v-card v-if="results.length >= 1 || results.length === null">
        <v-card-title class="text-25-security green-security font-weight-bold">
          <v-icon medium class="pr-2">account_circle</v-icon>
          Personas
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="message()"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="results"
          :search="search"
          disable-initial-sort
          class="elevation-1"
          no-data-text="Su búsqueda no dió resultados"
          rows-per-page-text="Filas por página"
        >
          <template slot="items" slot-scope="props">
            <tr @click="show_user(props.item)">
              <td :class="$vuetify.breakpoint.smAndDown ? 'text-xs-center py-1 px-0' : ''">
                <v-avatar>
                  <img 
                    :src="props.item.image"
                    :style="`border: 2px solid ${props.item.color}; background-color: ${props.item.color}`"
                  />
                </v-avatar>
              </td>
              <td :class="$vuetify.breakpoint.smAndDown ? 'text-xs-left px-0 py-1' : ''">
                {{ props.item.full_name }}
              </td>
              <td class="text-xs-left">{{ props.item.email }}</td>
              <td class="text-xs-left">{{ props.item.annexed }}</td>
            </tr>
          </template>
          <v-layout slot="no-results">
            <v-flex sm12>
              <v-card flat>
                <v-layout align-center justify-center row wrap fill-height>
                  <v-flex
                    sm12
                    class="text-29-security text-md-center font-weight-bold"
                    style="color: #525252"
                  >Su búsqueda "{{ search }}" no arrojó resultados.</v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data(){
    return{
      search: ""
    }
  },
  props: {
    results: {
      type: Array,
      required: false
    },
    headers: {
      type: Array,
      required: false
    }
  },
  methods: {
    ...mapActions("user", ["fetchUser"]),
    show_user(user) {
      this.fetchUser(user.id);
      this.$router.push({
        name: "user-show",
        params: { id: user.id }
      });
    },
    message() {
      return `Mostrando resultados para ${this.$route.params.query}`;
    }
  }
}
</script>

<style>
.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
  background: #e0f4ba;
}

.width-header-mobile {
  padding-left: 0px !important;
  padding-right: 90px !important;
}
</style>